module.exports = "<swiper [config]=\"swiperConfig\" [class.hidearrows]=\"hideArrows\">\r\n  <ng-content></ng-content>\r\n</swiper>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cierant-swiper/cierant-swiper.component.html
// module id = ./src/app/shared/components/cierant-swiper/cierant-swiper.component.html
// module chunks = main